/**
 * §11.4 Privacy Commitment — 4 principles.
 */

import React from 'react'
import clsx from 'clsx'
import {
  Filter, Target, UserCheck, Eye, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { PRIVACY_PRINCIPLES } from '../data'
import { TONE } from '../_shared'

const ICONS = { Filter, Target, UserCheck, Eye, Sparkles }

export default function PrivacyCommitment() {
  return (
    <section id="privacy" className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Privacy</Eyebrow>
          <SectionHeading align="center"
            title={<>Four principles that{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">govern personal data.</span></>}
            subtitle="We treat personal data as a responsibility, not a resource.  These principles apply to every module and every tenant on the platform."
          />
        </div>
        <div className="grid gap-3 md:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {PRIVACY_PRINCIPLES.map((p) => {
            const tone = TONE[p.tone] || TONE.orange
            const Icon = ICONS[p.iconKey] || Sparkles
            return (
              <div key={p.id} className={clsx(
                'relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl',
                'transition-all hover:border-white/20 hover:bg-white/[0.03] hover:-translate-y-[1px] overflow-hidden',
              )}>
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
                  </span>
                  <div>
                    <h4 className="text-[14.5px] font-semibold text-white leading-tight">{p.label}</h4>
                    <p className="text-[13px] text-zinc-400 leading-relaxed mt-1.5">{p.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
